<template>
  <div v-if="$template.enseigne_id != 4" class="ingredients-container px-4 py-8 !text-grey">
    <p class="uppercase font-bold lg:text-left text-center text-xs lg:text-base">
      Pour votre santé, Pratiquez une activité physique régulière
    </p>
    <p class="w-fit m-auto font-bold text-sm mt-2">
      <a href="https://www.mangerbouger.fr/" target="_blank" class="underline ">www.mangerbouger.fr</a>
    </p>
    <p v-if="$template.enseigne_id != 3" class="text-xs mt-4">
      <span v-if="$template.enseigne_id != 5">*</span>L'abus d'alcool est dangereux pour la santé - À consommer avec modération
    </p>
    
    <div v-if="$template.enseigne_id == 5" class="text-xs mt-2">
      <p>
        La Cave de Julien vous rappelle que la vente d'alcool aux mineurs est interdite. Certains produits sont proposés sous le millésime/année précédent(e) et/ou suivant(e). Photos non contractuelles. Contient des SULFITES.
      </p>
    </div>
    <div v-if="$template.enseigne_id != 5">
      <p class="uppercase text-xs font-bold mt-4 mb-4">Liste d'ingrédients</p>
      <p v-for="product in products" :key="product.id" class="text-xs">
        <span v-if="product.ingredients && product.ingredients != ''" class="font-bold">{{
          product.name
        }}</span>
        <span v-if="product.ingredients && product.ingredients != ''">: {{ product.ingredients }}</span>
      </p>
      <p v-if="$template.enseigne_id == 3" class="mt-2 text-xs">
        <span class="font-bold">Préconisations concernant les compléments alimentaires :</span> Ces produits ne sont pas des médicaments mais des compléments alimentaires. Il est recommandé de ne pas dépasser le dosage conseillé. Tenir hors de portée des enfants, de la chaleur et de l'humidité. À utiliser dans le cadre d’une alimentation variée, équilibrée et d’un mode de vie sain. Se référer à chaque produit en cas de préconisation spécifique à chaque produit. Ils sont fabriqués en France. (UI : Unités Internationales, AR : Apports de Référence).
      </p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    products() {
      return this.$store.products
    }
  },
}
</script>

<style scoped>
.ingredients-container {
  background-color: v-bind(
    "$template ? $template.products_ingredients_background_color : ''"
  );
}
</style>
